"use client"

import Logo from "./Logo"
import dynamic from "next/dynamic"
import DisabledSearchBar from "./DisabledSearchBar"
import DisabledLinks from "./DisabledLinks"

const SearchBar = dynamic(() => import("./SearchBar"), {
  ssr: false,
  loading: () => <DisabledSearchBar />,
})
const Links = dynamic(() => import("./Links"), {
  ssr: false,
  loading: () => <DisabledLinks />,
})

const Header = () => {
  return (
    <header className="fixed z-50 w-full py-3 px-3 sm:px-4 lg:px-10 flex items-center justify-between">
      <Logo />
      <Links />
      <SearchBar />
    </header>
  )
}

export default Header
